import { render, staticRenderFns } from "./summary-report.vue?vue&type=template&id=4b891888&scoped=true"
import script from "./summary-report.vue?vue&type=script&lang=js"
export * from "./summary-report.vue?vue&type=script&lang=js"
import style0 from "./summary-report.vue?vue&type=style&index=0&id=4b891888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b891888",
  null
  
)

export default component.exports